import { Helmet } from "react-helmet";

export default function BlogPostSEO({ title, description, slug, aio = "" }) {
  return (
    <Helmet>
      <title>{title} | PT Supersoft Sistemindo</title>

      <meta name="description" content={`${description} `} />

      <link
        rel="canonical"
        href={`https://ptsupersoft.com/blogs/detail/${slug}`}
      />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={`${description} `} />
      <meta
        property="og:url"
        content={`https://ptsupersoft.com/blogs/${slug}`}
      />

      <meta name="ai-search-summary" content={`${description} `} />
      <meta
        name="ai-search-tags"
        content="Infor SunSystems, Octave Attune EAM (Hexagon), case study, digital transformation"
      />
      {aio && (
        <script type="application/ld+json" data-react-helmet="true">
          {`${JSON.stringify(aio)}`}
        </script>
      )}
    </Helmet>
  );
}
